export default function DateTimePicker() {
  return {
    MuiDateTimePicker: {
      defaultProps: {
        desktopModeMediaQuery: '@media (min-width:480px)',
      },
    },
  };
}
